export default "__VITE_ASSET__DgILPYaD__"